import axios from "axios";

export default {
  namespaced: true,
  state: {
    commonData: {}
  },
  mutations: {
    SET_SETTINGS(state, settings) {
      state.commonData = settings;
    },
    CLEAR_SETTINGS(state) {
      state.commonData = {};
    }
  },
  actions: {
    async fetchSettings({ commit }) {
	  if (window.commonData) {
		console.log("📌 Lấy settings từ Blade template.");
		commit("SET_SETTINGS", window.commonData);
	  } else {
		console.log("📡 Fetch settings từ API...");
		const response = await axios.get("/api/options");
		commit("SET_SETTINGS", response.data);
	  }
	}
  },
  getters: {
    getCommonData: (state) => state.commonData
  }
};
